// extracted by mini-css-extract-plugin
export default {"label":"sidenavlink_label__ya0Rg"};